import { Brand } from "@/components/Brand";
import { Youtube, Instagram, Twitter } from "lucide-react";

export const Footer = () => (
  <footer className="border-t border-black/10 px-6 md:px-12 py-16 bg-[#F1F4F3]" data-testid="footer">
    <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
      <div className="md:col-span-6">
        <div className="font-display font-black text-4xl md:text-6xl tracking-tight leading-[0.95] text-[#0E1E2E]">
          Press play on<br />your <span className="text-brand">next chapter.</span>
        </div>
        <a href="#shows" className="inline-block mt-8 font-mono2 text-xs uppercase tracking-[0.2em] border-b border-brand pb-1 text-brand">
          Start watching →
        </a>
        <div className="flex items-center gap-4 mt-8 text-[#556673]">
          <a href="#" aria-label="YouTube" className="hover:text-brand transition-colors"><Youtube size={20} /></a>
          <a href="#" aria-label="Instagram" className="hover:text-brand transition-colors"><Instagram size={20} /></a>
          <a href="#" aria-label="Twitter" className="hover:text-brand transition-colors"><Twitter size={20} /></a>
        </div>
      </div>
      <div className="md:col-span-3">
        <p className="font-mono2 text-xs uppercase tracking-[0.2em] text-[#8797A3] mb-4">Explore</p>
        <div className="flex flex-col gap-2 text-sm text-[#556673]">
          <a href="#shows" className="hover:text-brand transition-colors">Shows</a>
          <a href="#about" className="hover:text-brand transition-colors">About</a>
        </div>
      </div>
      <div className="md:col-span-3">
        <p className="font-mono2 text-xs uppercase tracking-[0.2em] text-[#8797A3] mb-4">Contact</p>
        <p className="text-[#556673] text-sm leading-relaxed">hello@umgtmedia.com<br />umgtmedia.com</p>
      </div>
    </div>
    <div className="mt-16 pt-6 border-t border-black/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
      <Brand size={28} />
      <span className="font-mono2 text-[11px] uppercase tracking-[0.18em] text-[#8797A3]">© 2026 UMG Media — Ebooks · Podcasts · Shows</span>
    </div>
  </footer>
);
